module.exports = __webpack_public_path__ + "Gauge4_Red-2db2c672d81259090fff14fd990ec9ea.png";